import { useMutation } from '@tanstack/react-query'

import { baseAPICall } from 'services/baseAPICall'
import { clientInstance } from 'utils/http-client'

// Types
// Used for opening the EmailBison headless UI popup for adding email connections
export interface HeadlessUITokenResponse {
  token: string
}

// API calls
const getHeadlessUIToken = async (): Promise<HeadlessUITokenResponse> => {
  return baseAPICall<HeadlessUITokenResponse>(() =>
    clientInstance.post('/emailbison/headless-ui-token/')
  )
}

// Hooks
export const useGetHeadlessUIToken = () => {
  return useMutation({
    mutationFn: getHeadlessUIToken,
  })
}
